import {
  CodeSquareIcon,
  GlobeIcon,
  LinkIcon,
  LockIcon,
  PencilIcon,
  RepoIcon,
  RocketIcon,
} from "@primer/octicons-react";
import { MetaIcon, OpenAiIcon } from "../components/common/Icons";

export const RESOURCE_VISIBILITY_AVAILABLE_OPTIONS = [
  { name: "private", Icon: LockIcon },
  { name: "public", Icon: GlobeIcon },
  { name: "public-unlisted", Icon: LinkIcon },
];

export const EDITOR_TYPE_AVAILABLE_OPTIONS = [
  { name: "editor", Icon: PencilIcon },
  // ...
];

export const REPO_TYPE_AVAILABLE_OPTIONS = [
  { name: "repo-classic", Icon: RepoIcon },
  { name: "repo-snippet", Icon: CodeSquareIcon },
];

export const DEPLOY_TYPE_AVAILABLE_OPTIONS = [
  { name: "deploy", Icon: RocketIcon },
  // ...
];

export const RESOURCE_TYPE_AVAILABLE_OPTIONS = [
  ...EDITOR_TYPE_AVAILABLE_OPTIONS,
  ...REPO_TYPE_AVAILABLE_OPTIONS,
  ...DEPLOY_TYPE_AVAILABLE_OPTIONS,
];

export const AI_MODELS_AVAILABLE = [
  {
    id: "@cf/meta/llama-3.3-70b-instruct-fp8-fast",
    isAllowed: () => true,
    name: "Llama 3.3 70B (fp8)",
    Icon: MetaIcon,
  },
  {
    id: "@cf/meta/llama-4-scout-17b-16e-instruct",
    isAllowed: () => true,
    name: "Llama 4 17B Scout",
    Icon: MetaIcon,
  },
  {
    id: "gpt-4.1-nano-2025-04-14",
    isAllowed: (plan: string) => plan !== "plan-free",
    name: "GPT-4.1 nano",
    Icon: OpenAiIcon,
  },
  {
    id: "gpt-4.1-mini-2025-04-14",
    isAllowed: (plan: string) => plan !== "plan-free",
    name: "GPT-4.1 mini",
    Icon: OpenAiIcon,
  },
  {
    id: "gpt-4.1-2025-04-14",
    isAllowed: (plan: string) => plan !== "plan-free",
    name: "GPT-4.1",
    Icon: OpenAiIcon,
  },
  {
    id: "o4-mini-2025-04-16",
    isAllowed: (plan: string) => plan !== "plan-free",
    name: "o4-mini",
    Icon: OpenAiIcon,
  },
  {
    id: "o3-2025-04-16",
    isAllowed: (plan: string) => plan !== "plan-free",
    name: "o3",
    Icon: OpenAiIcon,
  },
];

export const AI_EDIT_FILENAMES = [
  { name: "README.md" },
  { name: "index.html" },
  { name: "index.js" },
  { name: "main.js" },
  { name: "image.svg" },
];
